define('cookie-handler',[],function () {
    var cookieHandler = {
        set: function (expireDays, name, value, domain) {
            var cookieDate = new Date();
            cookieDate.setDate(cookieDate.getDate() + expireDays);
            if (!domain) {
                document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + cookieDate.toGMTString() +
                ';path=/';
            } else {
                document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + cookieDate.toGMTString() +
                ';domain=' + domain + ';path=/';
            }
        },
        setTime: function (expireTime, name, value, domain) {
            var cookieDate = new Date();
            cookieDate.setTime(cookieDate.getTime() + expireTime);
            if (!domain) {
                document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + cookieDate.toGMTString() +
                ';path=/';
            } else {
                document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + cookieDate.toGMTString() +
                ';domain=' + domain + ';path=/';
            }
        },
        // set a session cookie (without expiration) that will be deleted when
        // the user closes the browser
        setSession: function (name, value, domain) {
            if (!domain) {
                document.cookie = name + '=' + encodeURIComponent(value) +
                ';path=/';
            } else {
                document.cookie = name + '=' + encodeURIComponent(value) +
                ';domain=' + domain + ';path=/';
            }
        },

        // borrowed from original labs implementation
        get: function (name) {
            if (document.cookie.length > 0) {
                var cookieStart = document.cookie.indexOf(name + '=');
                var cookieEnd;
                if (cookieStart !== -1) {
                    cookieStart = cookieStart + name.length + 1;
                    cookieEnd = document.cookie.indexOf(';', cookieStart);
                    if (cookieEnd === -1) {
                        cookieEnd = document.cookie.length;
                    }
                    return decodeURIComponent(document.cookie.substring(cookieStart, cookieEnd));
                }
            }
            return null;
        },

        clear: function (name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    };

    return cookieHandler;
});

